<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<app-login-popup></app-login-popup>
